// atoms/selectedTokenAtom.ts
import { atom } from "jotai";
import type { TokenBalance } from "@/lib/blockscout-api";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const selectedTokenAtom = atomWithStorage<TokenBalance | null>("selectedToken", null, {
    getItem: (key) => {
      const storedValue = sessionStorage.getItem(key);
      return storedValue ? JSON.parse(storedValue) : null;
    },
    setItem: (key, newValue) => {
      sessionStorage.setItem(key, JSON.stringify(newValue));
    },
    removeItem: (key) => {
      sessionStorage.removeItem(key);
    },
  });

  export const selectedNftAtom = atomWithStorage<TokenBalance | null>("selectedNft", null, {
    getItem: (key) => {
      const storedValue = sessionStorage.getItem(key);
      return storedValue ? JSON.parse(storedValue) : null;
    },
    setItem: (key, newValue) => {
      sessionStorage.setItem(key, JSON.stringify(newValue));
    },
    removeItem: (key) => {
      sessionStorage.removeItem(key);
    },
  });
